import axios from 'axios';

export const api = buildApi();

export function buildApi(extraPath = '') {
    const apiUrl = wp.root.replace(/\/$/, '');
    extraPath = extraPath.replace(/^\//, '');

    return axios.create({
        baseURL: `${apiUrl}/${extraPath}`,
    });
}

export const wpMediaApi = buildApi('/wp/v2/media/');
export const wpPostApi = buildApi('/wp/v2/posts');
export const wpPageApi = buildApi('/wp/v2/pages/');

export const razzMenuApi = buildApi('/razz/v1/menus/');
export const razzFormApi = buildApi('/razz/v1/form/');
export const razzNeighborhoodApi = buildApi('/razz/v1/neighborhoods');
export const razzNextPrevPostApi = buildApi('/razz/v1/get-recent-posts/');